module.exports = __webpack_public_path__ + "img/Returnsdfds.ce89347d.jpg";